/**
 * The phone app's words for a Lead's writes (piece 35, *Leads (batch CR7)*;
 * decisions 4410, 4540): the question each one-press move asks first, the note a
 * question answered on the web reads, and New Lead, spread into the one string
 * lookup beside the earlier batches' words. A word the web already says, such
 * as the banner's buttons, the four windows' titles and fields, the stage card's
 * Complete and Back to, or the suggested match's lines, is read from the web's
 * own `lead.*` key and is not repeated here.
 */
export const CRM_LEADS_STRINGS = {
  'mobile.lead.actions': 'Actions',
  'mobile.lead.confirm.callAttempt': 'This logs one outbound call attempt on the Lead.',
  'mobile.lead.confirm.hot': 'This marks the Lead Hot.',
  'mobile.lead.confirm.convertCompany': 'This makes a Company from what the Lead captured, with its Person where the Lead names one, and opens the Company.',
  'mobile.lead.confirm.release': 'This releases the held Lead into the queue.',
  'mobile.lead.confirm.block': 'This blocks the Lead, and it leaves the queue.',
  'mobile.lead.confirm.linkCompany': 'This links the Lead to the suggested company. The submitted text stays as it arrived.',
  'mobile.lead.confirm.linkPerson': 'This links the Lead to the suggested person. The submitted text stays as it arrived.',
  'mobile.lead.confirm.complete': 'This completes the stage, and the Lead moves to the next one.',
  'mobile.lead.confirm.back': 'This moves the Lead back to',
  'mobile.lead.confirm.backKept': 'The answers on every card stay.',
  'mobile.lead.unreachable': 'Nothing was changed, because the server did not answer. Check the connection, then try again.',
  'mobile.lead.noTerritories': 'No territories yet',
  'mobile.lead.valueProblem': 'Type the value as a number, such as 48500.',
  'mobile.lead.fileOnWeb': 'This question is answered by uploading the signed file, on the web.',
  'mobile.lead.new': 'New Lead',
  'mobile.lead.newHint': 'The company, email, phone, occasion and message are added with the pencil once the Lead is open.',
  'mobile.lead.nameRequired': 'A name is required.',
} as const;
